export class DashboardChartsModel {
  studentStateChart: any = {};
  studentRegionChart: any = {};
  studentBatchChart: any = {};
  studentGenderChart: any = {};
  studentAssignmentChart: any = {};
  studentStatusChart:any = {};
  recentUpcomingAssignmentList: any = [];
  studentInternshipCount: any = {};
  recentStartInternship: any = [];
  studentInternshipDetailsChart: any = {};
  mentorCount: any = [];
  menteeCount: any = [];
  mentorChart: any = {};
  menteeChart: any = {};
  batchWiseMentoringDocChart: any = {};
  batchwiseMentoringDocUploadsChart: any = {};
  recentlyAddedMentorCount: any = [];
  documentsNotUploadedData: any = [];
  applicantStateDataChart: any = {};
  applicantGenderData: any = {};
  applicantRegionData: any = {};
  applicantBranchData: any = {};
  sspHubAluminiChart: any = {};
  sSPHUBactiveStudentCount: any = "";
  sSPHUBactiveStudentLoginCountDatewise: any = "";
  sSPHUBall_active_users_last_3_months_count: any = "";
  sSPHUBposts_last_3_months_count: any = "";
  sSPHUBtotal_posts: any = "";
  sSPHUBalumni_profile_updates_count: any = "";
  applicantCategoryData:any={};
  // internshiptotalStudent:any = [];
  typeWiseAssignmentDetailCount:any=[];
  assignmentSkillChartFirst:any = {};
  assignmentSkillChartSecond:any = {};
  assignmentSkillChartThird:any = {};
  feedbackAssignedBatchWise:any={};
  feedbackUploadedBatchWise:any={};
}
